// extracted by mini-css-extract-plugin
export default {"confirm_actions":"ComfirmDeleteAccount_confirm_actions__qfPDg"};